<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Condições de Pagamento</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/financas">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Visualize e gerencie as condições de parcelamento permitidas nas vendas.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    <span class="menu-action-tooltip-wrapper" [matTooltip]="getTooltipAcoesSemSelecao()"
                        [matTooltipDisabled]="selection.hasValue()">
                        <button mat-menu-item (click)="excluirSelecionados()" [disabled]="!selection.hasValue()">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            <span>Excluir selecionados</span>
                        </button>
                    </span>
                </mat-menu>

                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/financas/condicoes-pagamento/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Nova condição
                </button>
            </div>
        </div>

        <app-alert-card [type]="isCondicaoPagamentoLivre ? 'warning' : 'success'" class="mb-4">
            @if (isCondicaoPagamentoLivre) {
            Em Configurações &gt;&gt; Vendas &gt;&gt; Geral, o toggle "Permitir condição de pagamento livre" está
            ativo: o vendedor pode digitar livremente como dividir o pagamento e estas condições não são exigidas.
            } @else {
            Com o toggle "Permitir condição de pagamento livre" Inativo, o vendedor só pode escolher entre
            as condições ativas cadastradas aqui, aplicáveis à forma de recebimento escolhida.
            }
        </app-alert-card>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar por nome...</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Busque por nome da condição">

                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 filter-container">
                    <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                        <mat-icon>cleaning_services</mat-icon>
                        Limpar Filtros
                    </button>
                </div>
            </div>
        </form>

        @if(_isLoading && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if(_dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="condicao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Condição </th>
                <td mat-cell *matCellDef="let element">
                    <div class="condicao-cell">
                        <span class="text-bold">{{element.nome}}</span>
                        <span class="condicao-resumo">{{resumoVencimentos(element)}}</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="estrutura">
                <th mat-header-cell *matHeaderCellDef> Estrutura </th>
                <td mat-cell *matCellDef="let element">
                    <div>{{parcelasLabel(element)}}</div>
                    <div class="condicao-resumo">{{modoLabel(element)}}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="juros">
                <th mat-header-cell *matHeaderCellDef class="text-end"> Juros (%) </th>
                <td mat-cell *matCellDef="let element" class="text-end">
                    {{ element.taxaJuros > 0 ? (element.taxaJuros | number:'1.2-2') : '—' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="formasAplicaveis">
                <th mat-header-cell *matHeaderCellDef> Formas aplicáveis </th>
                <td mat-cell *matCellDef="let element">
                    @if (element.formasAplicaveis.length === 0) {
                    <span class="status-badge badge-dot badge-cinza">
                        <mat-icon class="material-symbols-outlined badge-icon">all_inclusive</mat-icon>
                        qualquer forma configurável pela empresa
                    </span>
                    } @else {
                    <div class="formas-aplicaveis-list">
                        @for (forma of element.formasAplicaveis; track forma.idFormaRecebimento) {
                        <span class="status-badge badge-dot badge-cinza">{{forma.nome}}</span>
                        }
                    </div>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="situacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Situação </th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge badge-dot" [ngClass]="getStatusClass(element.isAtivo)">
                        {{ element.isAtivo ? 'Ativa' : 'Inativa' }}
                    </span>
                    @if (element.emUso) {
                    <div class="condicao-em-uso">em uso</div>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/condicoes-pagamento/cadastrar', element.idCondicaoPagamento]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="excluir(element)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idCondicaoPagamento) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary">
                        </mat-checkbox>
                        <div>
                            <div class="text-bold">{{item.nome}}</div>
                            <div class="condicao-resumo">{{resumoVencimentos(item)}}</div>
                        </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/condicoes-pagamento/cadastrar', item.idCondicaoPagamento]">
                            Editar
                        </button>
                        <button mat-menu-item (click)="excluir(item)">
                            Excluir
                        </button>
                    </mat-menu>
                </div>

                <div class="card-body-mobile">
                    <div class="card-row-mobile">
                        <span class="text-secondary">Estrutura</span>
                        <span>{{parcelasLabel(item)}} · {{modoLabel(item)}}</span>
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Juros</span>
                        <span>{{ item.taxaJuros > 0 ? (item.taxaJuros | number:'1.2-2') + '%' : '—' }}</span>
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Situação</span>
                        <span class="status-badge badge-dot" [ngClass]="getStatusClass(item.isAtivo)">
                            {{ item.isAtivo ? 'Ativa' : 'Inativa' }}
                        </span>
                    </div>
                </div>
            </div>
            }
        </div>

        @if (_isLoading || _dataSource.data.length < _totalRegistros) {
        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button class="btn-ver-mais" [disabled]="_isLoading" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="20"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>
        }

        } @else if (model.get('pesquisa')?.value) {
        <app-empty-list [title]="'Nenhuma condição encontrada'"
            [subTitle]="'Tente pesquisar por outro nome'"></app-empty-list>
        } @else {
        <app-empty-list [title]="'Nenhuma condição de pagamento cadastrada'"
            [subTitle]="'Cadastre as condições de parcelamento que a empresa permite usar nos documentos de venda'"></app-empty-list>
        }
    </div>
</div>